import ChangeInstallerModal from './change-installer-modal.vue'
export default ChangeInstallerModal
